import { Component } from '@angular/core';

/**
 * Generated class for the NewLubbuIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'new-lubbu-icon',
  templateUrl: 'new-lubbu-icon.html'
})
export class NewLubbuIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/new-lubbu-icon/new-lubbu-icon.ts